<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="card"> 
                    <div class="card-body">
                        <h1>Bulk Tour Instance Uploader</h1>
                        <div v-if="success != ''" class="alert alert-success" role="alert">
                            {{ 'File uploaded succesfully' }}
                        </div>

                        <form @submit="formSubmit" enctype="multipart/form-data">
                            
                            <div class="row">
                                <div class="col-md-12">
                                    <strong>CSV File: </strong>
                                    <input type="file" class="form-control" v-on:change="onImageChange">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-">
                                    <div class="form-check">
                                      <label class="form-check-label">
                                        <input type="checkbox" class="form-check-input" name="updatePricing" id="updatePricing" v-model="updatePricing" v-bind:value="updatePricing">
                                        Check box for pricing update only
                                      </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-">
                                    <div class="form-check">
                                      <label class="form-check-label">
                                        <input type="checkbox" class="form-check-input" name="updateFlightBudget" id="updateFlightBudget" v-model="updateFlightBudget">
                                        Update Flight Budget
                                      </label>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <button class="btn btn-success">Submit</button>
                                    <div v-if="processing != ''">
                                        <h5>{{ this.processing }} </h5>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            name: '',
            csv: '',
            success: '',
            processing: '',
            updatePricing: false,
            updateFlightBudget: false
        };
    },
    methods: {
        onImageChange(e){
            this.csv = e.target.files[0];
        },
        formSubmit(e) {
            e.preventDefault();
            this.processing = "Processing Data";
            let currentObj = this;
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Authorization': localStorage.getItem('token')
                }
            }

            let formData = new FormData();
            formData.append('csv', this.csv);
            formData.append('updateOnly', this.updatePricing)
            formData.append('updateFlightBudget', this.updateFlightBudget)
            axios.post(this.$api + 'csvupload', formData, config)
            .then(function (response) {
                currentObj.success = response.data.success;
                this.processing = "Processed successfully";
            })
            .catch(function (error) {
                if(error.response) 
                {
                    currentObj.output = error;
                }
            });
        }
    }
}

</script>